<template>
  <main class="container-fluid">
    <div class="segment" :class="{'section-loading': login_loading}">
      <h1 class="mb-0">登入</h1>
      <h4 class="mt-0">CRM 客戶關係管理</h4>
      <form class="form">
        <div class="form-group row">
          <label for="account" class="col-2 col-label-form text-right">帳號</label>
          <div class="col-9">
            <input type="text"
            name="account"
            id="account"
            class="form-control"
            :class="{'is-invalid': errors.has('account')}"
            placeholder="請輸入帳號"
            v-model="form.account"
            v-validate="'required'" />
          </div>
        </div>
        <div class="form-group row">
          <label for="password" class="col-2 col-label-form text-right">密碼</label>
          <div class="col-9">
            <input
            type="password"
            name="password"
            id="password"
            class="form-control"
            :class="{'is-invalid': errors.has('password')}"
            v-model="form.password"
            placeholder="請輸入密碼"
            v-validate="'required'"/>
          </div>
        </div>
        <div class="form-group">
          <!-- 由後端回傳錯誤內容 -->
          <div class="error-block" :style="{
            opacity: submitError ? 1 : 0
          }">
            <span class="error">
              您輸入的帳號或密碼有誤，請再次確認。
            </span>
          </div>
        </div>
        <div class="action">
          <button
          @click.prevent="doSubmit()"
          type="submit"
          class="btn btn-primary btn-block"
          :disabled="!isFormValid">
            登入
          </button>
          <a href="#" class="link">忘記密碼 ❯</a>
        </div>
      </form>
    </div>
    <form class="d-none" name="SAML" method="post" :action="SAMLForm.formAction">
      <input type="text" name="RelayState" v-model="SAMLForm.RelayState">
      <input type="text" name="SAMLRequest" v-model="SAMLForm.SAMLRequest">
      <input id="SAMLForm" type="submit" value="Submit">
    </form>
  </main>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import { getUserSSO} from '../../service'
import axiosFormSubmit from '../../service/axiosFormSubmit.js'
import getCookie from '@/service/getCookie'

export default {
  name: 'Login',
  data () {
    return {
      login_loading: false,
      submitError: false,
      form: {
        account: '',
        password: ''
      },
      samlStatus: '',
      SAMLForm:{
        formAction: '',
        RelayState: '',
        SAMLRequest: '',
      },
      localShow:false,  // SAML 開啟時 不要顯示 login 畫面
    }
  },
  computed: {
    ...mapGetters(['BaseUrl', 'SliceMode']),
    isFormValid() {
      let valid = true
      // 判斷欄位是否為空
      return Object.keys(this.fields).reduce(
        (bool, key) => {
          if(!this.fields[key].valid) valid = this.fields[key].valid
          return valid
        }, valid);
    }
  },
  methods: {
    ...mapActions(['updateUserToken', 'updateQueryKeyword', 'updateSamlStatus', 'updateUserRight']),
    checkSAML(){
      let url = '/servlet/HttpDispatcher/MXAuth/isLoggedIn'
      axiosFormSubmit(url,{},'引導登入頁').then(result => {
        this.login_loading = true
        if(result && result.returnMsg){
          const SAMLStatus = getCookie('saml-status')
          this.updateSamlStatus(SAMLStatus)
          if( SAMLStatus && SAMLStatus === 'on'){  // 如果 SAML 有開啟 formSubmit 出去導頁
            this.SAMLForm.formAction = result.detail.ssoUrl
            this.SAMLForm.RelayState = result.detail.RelayState
            this.SAMLForm.SAMLRequest = result.detail.SAMLRequest
            const submitForm = document.querySelector('#SAMLForm')
            setTimeout(() => {
              submitForm.click()
            }, 200);
            this.login_loading = false
          }else if( SAMLStatus && SAMLStatus === 'off'){ //  如果 SAML 關閉
            console.log('SAML 關閉');
            this.login_loading = false
            // this.localShow = true
            // this.$parent.appShow = true
          }else{  // 回傳的 detail 裡面沒有 ssoUrl & loginUrl 值
            console.log('API 錯誤');
            this.login_loading = false
            // this.localShow = true
            // this.$parent.appShow = true
          }
        }else{
          this.$toast.info({title: '登入錯誤'})
          this.login_loading = false
          // this.localShow = true
          // this.$parent.appShow = true
        }
      })
    },
    doSubmit () {
      // form submit 登入
      if(window.AJADev){ // for Offline mode
        getUserSSO().then(result => {
          if(result.body && result.body.userInfo){
            let user = result.body.userInfo
            user.workDate = result.body.workDate
            this.$store.dispatch({
              type: 'updateUserIP',
              data: result.body.ip
            })
            this.$store.dispatch({
              type: 'updateUserInfo',
              data: user
            })
            this.updateUserRight(user.apiKeyFunctionsPermission[user.apiKeys[0]])   // 寫入使用者權限
            this.updateUserToken(user.apiKeys[0])
            this.login_loading = false
            this.$router.push({path:'/'})
          } else {
            this.login_loading = false
            this.submitError = true
            console.log('登入失敗');
          }
        })
        return false
      }

      this.login_loading = true
      this.$validator.validateAll().then(result => {  // 判斷帳號密碼是否有輸入
        if (!result) return false;
        let url = '/servlet/HttpDispatcher/MXAuth/login'
        let data = {
          userID: this.form.account.toUpperCase(),
          passWD: this.form.password,
        }
        axiosFormSubmit(url,data,'使用者登入').then(result => {
          let userToken = decodeURI(getCookie('api-keys'))
          if(userToken){
            getUserSSO().then(result => {
              if(result.body && result.body.userInfo){
                let user = result.body.userInfo
                user.workDate = result.body.workDate
                this.$store.dispatch({                               // 寫入 server 端回覆的 IP
                  type: 'updateUserIP',
                  data: result.body.ip
                })
                this.$store.dispatch({
                  type: 'updateUserInfo',
                  data: user
                })
                this.updateUserRight(user.apiKeyFunctionsPermission[user.apiKeys[0]])   // 寫入使用者權限
                this.updateUserToken(JSON.parse(userToken)[0])
                this.login_loading = false
                this.$router.push({path:'/'})
              } else {
                this.login_loading = false
                this.submitError = true
                console.log('登入失敗');
              }
            })
          }else{
            this.login_loading = false
            this.submitError = true
            console.log('未接收到 Token 或是 API key 格式不對');
          }
        }) 
      
      })

    },
    // doSubmit () {
    //   this.$validator.validateAll().then(result => {
    //     if (!result) return false;

    //     // login api
    //     this.$router.push('/')
    //   });
    // }
  },
  mounted() {
    this.updateQueryKeyword('')
    if(window.AJADev || getCookie('api-keys')){
      this.$router.push({path:'/'})
    }else{
      this.checkSAML()
    }
  },
}
</script>
